var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { fetcher } from "@/api/schema";
import Filtering, { contains, expandNameTag } from "@/utils/filtering";
import { withPrefix } from "@/utils/redirect";
/**
 * Api endpoint handlers
 */
const getVisualizations = fetcher.path("/api/visualizations").method("get").create();
/**
 * Request and return data from server
 */
function getData(offset, limit, search, sort_by, sort_desc) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        const { data, headers } = yield getVisualizations({
            limit,
            offset,
            search,
            sort_by: sort_by,
            sort_desc,
            show_own: false,
            show_published: true,
            show_shared: true,
        });
        const totalMatches = parseInt((_a = headers.get("total_matches")) !== null && _a !== void 0 ? _a : "0");
        return [data, totalMatches];
    });
}
/**
 * Declare columns to be displayed
 */
const fields = [
    {
        title: "Title",
        key: "title",
        type: "operations",
        width: 40,
        operations: [
            {
                title: "View",
                icon: faEye,
                handler: (data) => {
                    if (data.type === "trackster") {
                        window.location.href = withPrefix(`/visualization/${data.type}?id=${data.id}`);
                    }
                    else {
                        window.location.href = withPrefix(`/plugins/visualizations/${data.type}/saved?id=${data.id}`);
                    }
                },
            },
        ],
    },
    {
        key: "annotation",
        title: "Annotation",
        type: "text",
    },
    {
        key: "username",
        title: "Owner",
        type: "text",
    },
    {
        key: "tags",
        title: "Tags",
        type: "tags",
        disabled: true,
    },
    {
        key: "update_time",
        title: "Updated",
        type: "date",
    },
];
/**
 * Declare filter options
 */
const validFilters = {
    title: { placeholder: "title", type: String, handler: contains("title"), menuItem: true },
    slug: { handler: contains("slug"), menuItem: false },
    tag: {
        placeholder: "tag(s)",
        type: "MultiTags",
        handler: contains("tag", "tag", expandNameTag),
        menuItem: true,
    },
};
/**
 * Grid configuration
 */
const gridConfig = {
    id: "visualizations-published-grid",
    fields: fields,
    filtering: new Filtering(validFilters, undefined, false, false),
    getData: getData,
    plural: "Visualizations",
    sortBy: "update_time",
    sortDesc: true,
    sortKeys: ["create_time", "title", "update_time"],
    title: "Published Visualizations",
};
export default gridConfig;
